import React, { KeyboardEvent } from 'react';

import cn from 'clsx';

export interface InputTextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  max?: number;
  limitMax?: boolean;
  preventMultiline?: boolean;
  neon?: string;
}

const InputTextarea = React.forwardRef<HTMLTextAreaElement, InputTextAreaProps>(
  (
    {
      value,
      className,
      max,
      neon,
      maxLength,
      limitMax = false,
      preventMultiline = false,
      ...props
    },
    ref
  ) => {
    console.log(neon);
    const rootCn = neon
      ? cn(
          'font-display w-full h-full overflow-y-auto text-base bg-transparent focus:outline-none text-white',
          className
        )
      : cn(
          'font-display w-full h-full overflow-y-auto rounded-md border-gray-darkest text-base focus:outline-none',
          {
            'text-black': !!value,
            'text-gray-darkest': !value,
          },
          className
        );
    const containerCn = neon
      ? cn(
          'font-display w-full h-full overflow-y-auto border-3 rounded-md border-gray-darkest text-base focus:outline-none',
          {
            'text-black': !!value,
            'text-gray-darkest': !value,
          },
          className
        )
      : cn(
          'font-display w-full h-full overflow-y-auto bg-white border-3 rounded-md border-gray-darkest text-base focus:outline-none',
          {
            'text-black': !!value,
            'text-gray-darkest': !value,
          },
          className
        );
    const count = value?.toString().length || 0;

    const onKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
      if (e.key === 'Enter') e.preventDefault();
    };

    return (
      <div className={containerCn}>
        <textarea
          ref={ref}
          className={rootCn}
          style={{ borderBottom: `2px solid ${neon}` }}
          cols={10}
          wrap="soft"
          onKeyPress={preventMultiline ? onKeyPress : undefined}
          maxLength={
            maxLength !== undefined ? maxLength : limitMax ? max : undefined
          }
          value={value}
          {...props}
        />
        {max && (
          <div
            className={
              neon
                ? cn('text-right font-semibold', {
                    'text-red font-bold': count > max,
                    'text-gray-400': count <= max,
                  })
                : cn('text-right font-semibold', {
                    'text-red font-bold': count > max,
                    'text-gray-darkest': count <= max,
                  })
            }
          >
            {count} / {max}
          </div>
        )}
      </div>
    );
  }
);

export default InputTextarea;
